import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
  const $this = this;
  const { $charge, $timer } = this;

  const pollConfig = {
    onBegin() { $timer.start() },
    onCancel() { pollConfig.onComplete() },
    onSuccessful() { SuccessView && SuccessView.activate.call($this) },
    onComplete() { /* self.console.log({ ...$this }) */ $timer.clear(), $this.QR_CODE = null }
  }

  return (view = ViewFactory({
    NAME: 'NQR_CODE_VIEW',
    mutables: { timerCurrent: 'CURRENT_TIME' },
    constants: {
      get qrcode() { return $this.QR_CODE },
      instruction: 'Scan the QR Code below on your bank\'s mobile app to complete the payment'
    },
    next() {
      $charge.poll(pollConfig);
    }
  }).call(this));
}
